import { Button, Classes, Tab, Tabs } from "@blueprintjs/core"
import { useCallback, useState } from "react"
import { useFormContext } from "react-hook-form"
import { DatasetSuggestV2 } from "../../../../components/DatasetSuggestV2"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { DashboardItemForm, DashboardUpdateCreateForm } from "../types/dashboardForm"
import { DialogBody, FooterContainer } from "./BulkAddDatasetModal.styled"
import { FundamentalsPanel } from "./FundamentalPanel"
import { SingleAddModalStyled } from "./SingleAddModal.styled"
import { DashboardItem } from "../../../../types/macroApi"

interface SingleAddModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export const SingleAddModal = ({ isOpen, setIsOpen }: SingleAddModalProps) => {
  const { setValue, getValues } = useFormContext<DashboardUpdateCreateForm>()
  const [activeTabId, setActiveTabId] = useState<string>("datasets")
  const [selectedDashboardItem, setSelectedDashboardItem] = useState<DashboardItemForm | null>(null)

  const items = getValues("items") as DashboardItemForm[]

  const handleClose = useCallback(() => {
    setIsOpen(false)
    setActiveTabId("datasets")
  }, [setIsOpen])

  const handleAddItem = useCallback(() => {
    if (!selectedDashboardItem) return
    setValue("items", [...(items || []), selectedDashboardItem], {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true,
    })
    setIsOpen(false)
    setSelectedDashboardItem(null)
  }, [selectedDashboardItem, setValue, items, setIsOpen])

  return (
    <SingleAddModalStyled
      className="bp5-dark"
      isOpen={isOpen}
      title="Add Item"
      onClose={handleClose}
    >
      <DialogBody className={Classes.DIALOG_BODY}>
        <FlexContainer flexDirection="column" gap="10px">
          <Tabs
            id="single-add-tabs"
            selectedTabId={activeTabId}
            onChange={id => setActiveTabId(id as string)}
          >
            <Tab
              id="datasets"
              title="Datasets"
              panel={
                <DatasetSuggestV2
                  onSelect={dataset => {
                    if (!dataset) return
                    setSelectedDashboardItem({
                      dataset_id: dataset.id,
                      dataset_name: dataset.name,
                      dataset_long_name: dataset.long_name,
                    })
                  }}
                />
              }
            />
            <Tab
              id="fundamentals"
              title="Fundamentals"
              panel={<FundamentalsPanel onChangeCandidate={setSelectedDashboardItem} />}
            />
          </Tabs>
        </FlexContainer>
      </DialogBody>
      <div className={Classes.DIALOG_FOOTER}>
        <FooterContainer>
          <Button
            intent="primary"
            icon="add"
            onClick={handleAddItem}
            disabled={!selectedDashboardItem}
          >
            Add
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </FooterContainer>
      </div>
    </SingleAddModalStyled>
  )
}

export default SingleAddModal
